// Leaflet チラシ画像を管理する model クラス
// チラシ画像の表示位置や大きさなどをLeafletViewのためにSceneのインスタンスなどから決定する
class Leaflet {
  static initClass() {
    this.prototype.padding = 20
  }

  constructor(view, scene) {
    this.view = view
    this.scene = scene
  }

  initialize() {
    // NOTE: avoid to compute width / height ratio directly with @view.element here
    // because ie8 sometimes returns wrong value
    const image = new Image()
    image.src = this.view.element.attr('src')
    return $(image).on('load', () => {
      this.ratio = image.width / image.height
      return this.view.initialize()
    })
  }

  position() {
    const size = this.size()
    return {
      top: (this.scene.height - size.height) / 2 - this.scene.dy,
      left: (this.scene.width - size.width) / 2 - this.scene.dx,
    }
  }

  size() {
    const base = this.baseSize()

    return {
      width: base.width * this.scene.magnificationRatio(),
      height: base.height * this.scene.magnificationRatio(),
    }
  }

  baseSize() {
    let width
    const sceneRatio =
      (this.scene.width - 2 * this.padding) / (this.scene.height - 2 * this.padding)

    if (this.ratio > sceneRatio) {
      // widthが長い
      width = this.scene.width - 2 * this.padding
      return {
        width,
        height: width / this.ratio,
      }
    } else {
      const height = this.scene.height - 2 * this.padding
      return {
        width: height * this.ratio,
        height,
      }
    }
  }
}

export default Leaflet;
